"use strict";

exports.__esModule = true;
exports.AuditLogRoutes = AuditLogRoutes;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _System = require("../../../System");
var _AuditLogListScreen = require("../AuditLogListScreen");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Widgets = require("../../Widgets");
var _auditLogWidgets = require("../../../Utils/auditLogWidgets");
var _AuditLogDetails = require("../AuditLogDetails/AuditLogDetails");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var settings = {
  selection: {
    allowReportingPeriod: true
  }
};
function AuditLogRoutes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_Widgets.WidgetsContext.Provider, {
    value: {
      auditLogWidgets: (0, _auditLogWidgets.auditLogWidgets)().filter(function (widget) {
        return !!widget;
      })
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AuditLogDetails"),
    element: /*#__PURE__*/_react["default"].createElement(_Core.CheckAccessRoute, {
      permission: "VIEW_AUDIT_LOG",
      render: function render(props) {
        var auditLogId = props.match.params.id;
        if (auditLogId) {
          return /*#__PURE__*/_react["default"].createElement(_AuditLogDetails.AuditLogDetails, _extends({}, props, {
            auditLogId: auditLogId,
            isFullScreen: true
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: new Error("id is undefined")
        });
      }
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("AuditLogList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_Core.CheckAccessRoute, {
      permission: "VIEW_AUDIT_LOG",
      component: _AuditLogListScreen.AuditLogListScreen
    })
  })), children));
}